import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { announceChannelAdd, announceChannelUpdate } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  data: function data() {
    return {
      dialogFormVisible: false,
      paramsData: {
        announce_channel_name: "",
        announce_channel_mark: "",
        id: ""
      },
      rules: {
        announce_channel_name: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        announce_channel_mark: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data.id) {
                  _this.paramsData = _objectSpread({}, data);
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.paramsData = {
        announce_channel_name: "",
        announce_channel_mark: "",
        id: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(vali) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (vali) {
                    reqFn = _this2.paramsData.id ? announceChannelUpdate : announceChannelAdd;
                    reqFn(_objectSpread(_objectSpread({}, _this2.paramsData), {}, {
                      game_id: _this2.rawData.game_id
                    }, _this2.propsData)).then(function (res) {
                      if (res.status == 200) {
                        Message.success(_this2.$t('operationSuccess'));
                        _this2.dialogFormVisible = false;

                        _this2.$emit("change");
                      }
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};